import {API_DRIVER} from "../config/axios";
import {CfgAttributesNames} from "../util/constants";

export interface ICfgAttributeCreateEdit {
    attr_name: CfgAttributesNames
    attr_value: string
    attr_description: string | null
}

const getCfgAttributesRequestUrl = (endpointUrl: string) => {
    return `/api/cfg-attributes${endpointUrl}`
}

const CfgAttributeService = {
    fetchAttributes: () => {
        return API_DRIVER.get(getCfgAttributesRequestUrl(``))
    },
    fetchAttributeValue: (name: string) => {
        return API_DRIVER.get(getCfgAttributesRequestUrl(`/${name}`))
    },
    createAttribute: (body: ICfgAttributeCreateEdit) => {
        return API_DRIVER.post(getCfgAttributesRequestUrl(``), body)
    },
    editAttribute: (body: ICfgAttributeCreateEdit) => {
        return API_DRIVER.put(getCfgAttributesRequestUrl(`/${body.attr_name}`), body)
    }
}

export default CfgAttributeService
